import { z } from "zod";
import { TopolBlockCssClassSchema, TopolBlockSchema } from "../commonSchema";

export const TopolDynamicBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-dynamic"),
  content: z.string().catch(""),
  identifier: z.string().catch("email"),
  feed: z.string().catch(""),
  attributes: z
    .object({
      containerWidth: z.number().catch(600),
      "css-class": TopolBlockCssClassSchema.optional().catch(undefined),
    })
    .catch({
      containerWidth: 600,
    }),
});

export type TopolDynamicBlock = z.infer<typeof TopolDynamicBlockSchema>;
